/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiResponseDto,
  CreateOrganizationDto,
  OrganizationControllerFindAllParams,
  OrganizationControllerFindOne200,
  OrganizationControllerGetOverview200,
  OrganizationControllerGetPublicInfo200,
  OrganizationControllerUpdateLogoBody,
  UpdateOrganizationCountryDto,
  UpdateOrganizationDto,
  UpdateOrganizationTermsDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get all organizations
 */
export const organizationControllerFindAll = (
    params?: OrganizationControllerFindAllParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/organizations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getOrganizationControllerFindAllQueryKey = (params?: OrganizationControllerFindAllParams,) => {
    return [`/organizations`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationControllerFindAllInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerFindAll>>>, TError = ErrorType<unknown>>(params?: OrganizationControllerFindAllParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerFindAll>>> = ({ signal }) => organizationControllerFindAll(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerFindAllInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerFindAll>>>
export type OrganizationControllerFindAllInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get all organizations
 */
export const useOrganizationControllerFindAllInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerFindAll>>>, TError = ErrorType<unknown>>(
 params?: OrganizationControllerFindAllParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerFindAllInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerFindAll>>, TError = ErrorType<unknown>>(params?: OrganizationControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerFindAll>>> = ({ signal }) => organizationControllerFindAll(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerFindAll>>>
export type OrganizationControllerFindAllQueryError = ErrorType<unknown>

/**
 * @summary Get all organizations
 */
export const useOrganizationControllerFindAll = <TData = Awaited<ReturnType<typeof organizationControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: OrganizationControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create new organization
 */
export const organizationControllerCreate = (
    createOrganizationDto: CreateOrganizationDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationDto
    },
      options);
    }
  


export const getOrganizationControllerCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreate>>, TError,{data: CreateOrganizationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreate>>, TError,{data: CreateOrganizationDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerCreate>>, {data: CreateOrganizationDto}> = (props) => {
          const {data} = props ?? {};

          return  organizationControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerCreate>>>
    export type OrganizationControllerCreateMutationBody = CreateOrganizationDto
    export type OrganizationControllerCreateMutationError = ErrorType<void>

    /**
 * @summary Create new organization
 */
export const useOrganizationControllerCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreate>>, TError,{data: CreateOrganizationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerCreate>>,
        TError,
        {data: CreateOrganizationDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get organization by ID
 */
export const organizationControllerFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationControllerFindOne200>(
      {url: `/organizations/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationControllerFindOneQueryKey = (id: string,) => {
    return [`/organizations/${id}`] as const;
    }

    
export const getOrganizationControllerFindOneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerFindOne>>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerFindOne>>> = ({ signal }) => organizationControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerFindOneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerFindOne>>>
export type OrganizationControllerFindOneInfiniteQueryError = ErrorType<void>

/**
 * @summary Get organization by ID
 */
export const useOrganizationControllerFindOneInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerFindOne>>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerFindOneInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerFindOne>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerFindOne>>> = ({ signal }) => organizationControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerFindOne>>>
export type OrganizationControllerFindOneQueryError = ErrorType<void>

/**
 * @summary Get organization by ID
 */
export const useOrganizationControllerFindOne = <TData = Awaited<ReturnType<typeof organizationControllerFindOne>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update organization
 */
export const organizationControllerUpdate = (
    id: string,
    updateOrganizationDto: UpdateOrganizationDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/organizations/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationDto
    },
      options);
    }
  


export const getOrganizationControllerUpdateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdate>>, TError,{id: string;data: UpdateOrganizationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdate>>, TError,{id: string;data: UpdateOrganizationDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdate>>, {id: string;data: UpdateOrganizationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  organizationControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdate>>>
    export type OrganizationControllerUpdateMutationBody = UpdateOrganizationDto
    export type OrganizationControllerUpdateMutationError = ErrorType<void>

    /**
 * @summary Update organization
 */
export const useOrganizationControllerUpdate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdate>>, TError,{id: string;data: UpdateOrganizationDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdate>>,
        TError,
        {id: string;data: UpdateOrganizationDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete organization
 */
export const organizationControllerRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/organizations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getOrganizationControllerRemoveMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerRemove>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  organizationControllerRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerRemove>>>
    
    export type OrganizationControllerRemoveMutationError = ErrorType<void>

    /**
 * @summary Delete organization
 */
export const useOrganizationControllerRemove = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get organization statistics
 */
export const organizationControllerGetStats = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDto>(
      {url: `/organizations/${id}/stats`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationControllerGetStatsQueryKey = (id: string,) => {
    return [`/organizations/${id}/stats`] as const;
    }

    
export const getOrganizationControllerGetStatsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerGetStats>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetStatsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetStats>>> = ({ signal }) => organizationControllerGetStats(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetStats>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetStatsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetStats>>>
export type OrganizationControllerGetStatsInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get organization statistics
 */
export const useOrganizationControllerGetStatsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerGetStats>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerGetStatsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationControllerGetStatsQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetStats>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetStatsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetStats>>> = ({ signal }) => organizationControllerGetStats(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetStats>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetStatsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetStats>>>
export type OrganizationControllerGetStatsQueryError = ErrorType<unknown>

/**
 * @summary Get organization statistics
 */
export const useOrganizationControllerGetStats = <TData = Awaited<ReturnType<typeof organizationControllerGetStats>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerGetStatsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update organization country
 */
export const organizationControllerUpdateCountry = (
    id: string,
    updateOrganizationCountryDto: UpdateOrganizationCountryDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/organizations/${id}/country`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationCountryDto
    },
      options);
    }
  


export const getOrganizationControllerUpdateCountryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateCountry>>, TError,{id: string;data: UpdateOrganizationCountryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateCountry>>, TError,{id: string;data: UpdateOrganizationCountryDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdateCountry>>, {id: string;data: UpdateOrganizationCountryDto}> = (props) => {
          const {id,data} = props ?? {};

          return  organizationControllerUpdateCountry(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateCountryMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdateCountry>>>
    export type OrganizationControllerUpdateCountryMutationBody = UpdateOrganizationCountryDto
    export type OrganizationControllerUpdateCountryMutationError = ErrorType<void>

    /**
 * @summary Update organization country
 */
export const useOrganizationControllerUpdateCountry = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateCountry>>, TError,{id: string;data: UpdateOrganizationCountryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdateCountry>>,
        TError,
        {id: string;data: UpdateOrganizationCountryDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateCountryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update organization logo (multipart file upload)
 */
export const organizationControllerUpdateLogo = (
    id: string,
    organizationControllerUpdateLogoBody: OrganizationControllerUpdateLogoBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      const formData = new FormData();
formData.append('file', organizationControllerUpdateLogoBody.file)

      return customInstance<ApiResponseDto>(
      {url: `/organizations/${id}/logo`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getOrganizationControllerUpdateLogoMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateLogo>>, TError,{id: string;data: OrganizationControllerUpdateLogoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateLogo>>, TError,{id: string;data: OrganizationControllerUpdateLogoBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdateLogo>>, {id: string;data: OrganizationControllerUpdateLogoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  organizationControllerUpdateLogo(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateLogoMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdateLogo>>>
    export type OrganizationControllerUpdateLogoMutationBody = OrganizationControllerUpdateLogoBody
    export type OrganizationControllerUpdateLogoMutationError = ErrorType<void>

    /**
 * @summary Update organization logo (multipart file upload)
 */
export const useOrganizationControllerUpdateLogo = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateLogo>>, TError,{id: string;data: OrganizationControllerUpdateLogoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdateLogo>>,
        TError,
        {id: string;data: OrganizationControllerUpdateLogoBody},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateLogoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get basic organization info (public)
 */
export const organizationControllerGetPublicInfo = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationControllerGetPublicInfo200>(
      {url: `/organizations/${id}/public-info`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationControllerGetPublicInfoQueryKey = (id: string,) => {
    return [`/organizations/${id}/public-info`] as const;
    }

    
export const getOrganizationControllerGetPublicInfoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetPublicInfoQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>> = ({ signal }) => organizationControllerGetPublicInfo(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetPublicInfoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>>
export type OrganizationControllerGetPublicInfoInfiniteQueryError = ErrorType<void>

/**
 * @summary Get basic organization info (public)
 */
export const useOrganizationControllerGetPublicInfoInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerGetPublicInfoInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationControllerGetPublicInfoQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetPublicInfoQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>> = ({ signal }) => organizationControllerGetPublicInfo(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetPublicInfoQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>>
export type OrganizationControllerGetPublicInfoQueryError = ErrorType<void>

/**
 * @summary Get basic organization info (public)
 */
export const useOrganizationControllerGetPublicInfo = <TData = Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetPublicInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerGetPublicInfoQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get organization configuration overview
 */
export const organizationControllerGetOverview = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationControllerGetOverview200>(
      {url: `/organizations/${id}/overview`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationControllerGetOverviewQueryKey = (id: number,) => {
    return [`/organizations/${id}/overview`] as const;
    }

    
export const getOrganizationControllerGetOverviewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerGetOverview>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetOverviewQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetOverview>>> = ({ signal }) => organizationControllerGetOverview(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetOverviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetOverview>>>
export type OrganizationControllerGetOverviewInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get organization configuration overview
 */
export const useOrganizationControllerGetOverviewInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof organizationControllerGetOverview>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerGetOverviewInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationControllerGetOverviewQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerGetOverviewQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerGetOverview>>> = ({ signal }) => organizationControllerGetOverview(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationControllerGetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerGetOverview>>>
export type OrganizationControllerGetOverviewQueryError = ErrorType<unknown>

/**
 * @summary Get organization configuration overview
 */
export const useOrganizationControllerGetOverview = <TData = Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerGetOverview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationControllerGetOverviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update organization terms and conditions URL
 */
export const organizationControllerUpdateTermsAndConditionsUrl = (
    id: string,
    updateOrganizationTermsDto: UpdateOrganizationTermsDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/organizations/${id}/terms-and-conditions-url`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationTermsDto
    },
      options);
    }
  


export const getOrganizationControllerUpdateTermsAndConditionsUrlMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateTermsAndConditionsUrl>>, TError,{id: string;data: UpdateOrganizationTermsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateTermsAndConditionsUrl>>, TError,{id: string;data: UpdateOrganizationTermsDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdateTermsAndConditionsUrl>>, {id: string;data: UpdateOrganizationTermsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  organizationControllerUpdateTermsAndConditionsUrl(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateTermsAndConditionsUrlMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdateTermsAndConditionsUrl>>>
    export type OrganizationControllerUpdateTermsAndConditionsUrlMutationBody = UpdateOrganizationTermsDto
    export type OrganizationControllerUpdateTermsAndConditionsUrlMutationError = ErrorType<void>

    /**
 * @summary Update organization terms and conditions URL
 */
export const useOrganizationControllerUpdateTermsAndConditionsUrl = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdateTermsAndConditionsUrl>>, TError,{id: string;data: UpdateOrganizationTermsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdateTermsAndConditionsUrl>>,
        TError,
        {id: string;data: UpdateOrganizationTermsDto},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateTermsAndConditionsUrlMutationOptions(options);

      return useMutation(mutationOptions);
    }
    